import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body1, makeStyles, Spinner, Subtitle1, tokens, } from '@fluentui/react-components';
import { ErrorCircleRegular, InfoRegular, ShieldLockRegular, } from '@fluentui/react-icons';
const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: tokens.spacingVerticalM,
        minHeight: '100%',
        padding: tokens.spacingHorizontalXXL,
        boxSizing: 'border-box',
        textAlign: 'center',
    },
    icon: { fontSize: '48px', color: tokens.colorNeutralForeground3 },
    error: { color: tokens.colorPaletteRedForeground1 },
    description: { maxWidth: '480px', color: tokens.colorNeutralForeground2 },
});
const ICONS = {
    info: InfoRegular,
    error: ErrorCircleRegular,
    denied: ShieldLockRegular,
};
/** Tela de estado: carregando, erro, sem acesso, página inexistente. */
export function StatusScreen({ title, description, action, loading = false, tone = 'info', }) {
    const styles = useStyles();
    const Icon = ICONS[tone];
    return (_jsxs("div", { className: styles.root, role: tone === 'error' ? 'alert' : 'status', children: [loading ? (_jsx(Spinner, {})) : (_jsx(Icon, { className: tone === 'error' ? styles.error : styles.icon, fontSize: 48 })), _jsx(Subtitle1, { children: title }), description !== undefined && (_jsx(Body1, { className: styles.description, children: description })), action] }));
}
//# sourceMappingURL=StatusScreen.js.map